var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workbench-grid"},[_c('WorkflowScheme',{staticStyle:{"margin":"3rem","max-width":"130rem","width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }